import styled from 'styled-components';
import { Bubble } from '@twnel/web-components';

const StyledBubble = styled(Bubble)`
  opacity: 1;
  width: ${({ width }) => width || 'auto'};
  max-width: 140px;
  height: auto;
  padding: .25rem .5rem;
  font-size: 0.7rem;
  line-height: 100%;
  text-align: center;
  border-radius: 2rem;
`;

export default StyledBubble;
